import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider";
import type { AppRole } from "./oidcConfig";

/**
 * doh_web_frontend's middleware.ts only protected `/donor/*` and
 * `/blood_bank/*` — `/hospital/*`, `/it_support/*`, and `/campaign_org/*`
 * were completely unguarded. Every dashboard route goes through this
 * component now; roles are enforced too, not just "is logged in", since
 * 54 of 55 backend calls in the original also went out with no
 * Authorization header at all (see api/baseQuery.ts for that fix).
 */
export function RequireAuth({ children, allow }: { children: ReactNode; allow?: AppRole[] }) {
  const { isAuthenticated, isLoading, role } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <p className="text-gray-500">Loading…</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  if (allow && !allow.includes(role)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
